import { JobWithRetest } from "../../../../../../../server/types/request/report/simulation";

/**
 * 現行品のデータを表示するか否か
 * - 類似品：非表示
 * - 現行品：表示
 * - [再調査] 類似品：非表示
 * - [再調査] 現行品：表示
 * @param {JobWithRetest} job
 * @returns {boolean}
 */
export const displayCurrentProduct = (job: JobWithRetest): boolean => {
	if (job.hasSimilarProduct) return false;
	if (job.hasCurrentProduct) return true;
	const { retestJob } = job;
	// 再調査がないパターンはそもそも現行品がない
	if (retestJob == null) return false;
	if (retestJob.hasSimilarProduct) return false;
	if (retestJob.hasCurrentProduct) return true;
	return false;
};
